import { GrowthBook } from "@growthbook/growthbook"
import { harvestExperimentAssignment } from "@/common/harvester"

const growthbook = new GrowthBook({
  enableDevMode: false,
  trackingCallback: (experiment, result) => {
    harvestExperimentAssignment(experiment.key, result.key)

    console.log("Viewed Experiment", {
      experimentId: experiment.key,
      variationId: result.key,
    })
  },
})

export default growthbook
